const validateCpf = cpf => {
    if (!cpf) return false
    if (cpf.includes('.')) { cpf = cpf.split('.').join(''); cpf = cpf.split('-').join(''); }
    let Soma = 0; let Resto;
    if (cpf == "00000000000") return false;
    for (let i=1; i<=9; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(cpf.substring(9, 10)) ) return false;
    Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i-1, i)) * (12 - i);
    Resto = (Soma * 10) % 11; 
    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(cpf.substring(10, 11) ) ) return false;
    return true;
}

const validateFone = fone => {
    if (!fone) return false
    fone = fone.match(/\d+/g).join('')
    return fone.length === 10 || fone.length === 11
}

const phoneMask = value => value.length < 15 ?
    ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/] :
    ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

export { validateCpf, validateFone, phoneMask }